var Provider = require('./Provider');
var moduleSelector = require('diy/site-admin/module-selector/moduleSelector');
var appsCatalog = require('diy/site-admin/apps-catalog/appsCatalog');

/**
 * Search provider class for searching in content elements (modules and apps)
 */
(function() {
    'use strict';

    var Elements = Provider.extend({
        indexUrl: '/app/cms/search/elementsindex/',

        initialize: function() {
            this.indexUrl += '?cacheKey=' + jimdoData.search.elementsCacheKey;
        },

        action: function(app) {

            // trigger upsell dialog
            if (app.isUpsell) {
                diy.editor.deeplinking.requestPath([
                    { label: 'siteadmin', params: app.webcomponentId.toLowerCase() }
                ]);
                return;
            }

            Modul.abortEditingModules();

            var isInstalledFn = appsCatalog.isWebcomponentInstalled;
            if (app.type != 'webcomponent' || isInstalledFn(app.webcomponentId)) {
                var itemType = app.type == 'webcomponent' ? 'webcomponent' : 'module',
                    id = app.type == 'webcomponent' ? app.webcomponentId : app.id;
                moduleSelector.default.jumpToItem(itemType, id);
            } else {
                // not installed webcomponent: link to catalog
                var catalogUrl = appsCatalog.getDetailPageNoBackLinkUrl(app.webcomponentId);
                appsCatalog.customOpen(catalogUrl);
            }
        }
    });

    module.exports = Elements;

}());



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/search/providers/Elements.js
 ** module id = 850
 ** module chunks = 0
 **/